/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

import { updateExitModalStatus } from '../../../actions/signingRoomActions';
import { logoutUrl } from '../../../common/authAPI';
import { DesktopHeader } from '@components/DesktopHeader/DesktopHeader';
import { isNotaryPortal, isSigningRoute, isDocumentPageRoute, isSigningRoomRoute } from '@utils/routing';

export namespace NotaryHeader {
  export interface Props {}
}

export const NotaryHeader: React.FC<NotaryHeader.Props> = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [headerLinks, setHeaderLinks] = useState<any>([]);

  const getHeaderLinks = () => {
    if (isSigningRoute(location.pathname)) {
      return [
        {
          display: 'Exit',
          handleClick() {
            updateExitModalStatus(true)(dispatch);
          },
        },
      ];
    } else if (isDocumentPageRoute(location.pathname)) {
      return [
        {
          display: 'Exit',
          handleClick() {
            window.close();
          },
        },
      ];
    } else {
      return [
        {
          display: 'Logout',
          handleClick() {
            window.location.href = logoutUrl;
          },
        },
      ];
    }
  };

  useEffect(() => {
    setHeaderLinks(getHeaderLinks());
  }, [location.pathname]);

  return !isNotaryPortal(location.pathname) && !isSigningRoomRoute(location.pathname) ? (
    <DesktopHeader data-it="NotaryHeader" headerLinks={headerLinks} />
  ) : null;
};
